/**
 * Created by vagrant on 10.1.2017.
 */
import fetch from 'isomorphic-fetch';
import {getToken} from './getToken';

const AWS_URL = window.configuration.awsUrl;

// api/mydata
export function fetchMyData() {
  return new Promise((resolve, reject) => {
    getToken().then(token => {
      if (token.error) {
        reject({'error': "not authorized"});
      } else
      return fetch(`${AWS_URL}api/mydata`, {
        headers: {
            'Accept': 'application/json',
            'Authorization': token
        },
        method: 'get',
      }).then(response => resolve (response.json())); 
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/authService.js